// export function slideToggle(element, timing = 500, attribute = 'height', display = 'block') {
//     element.style.transition = `${attribute} ${timing}ms ease`;
//     element.style.overflow = 'hidden';

//     if (element.style.display !== display) {
//         element.style.display = 'block';
//         element.style[attribute] = 'auto';

//         let value = (attribute === 'width' ? element.clientWidth : element.clientHeight) + 'px';
//         element.style[attribute] = '0px';
//         setTimeout(() => element.style[attribute] = value, 0);
//     } else {
//         element.style[attribute] = '0px';
//         element.addEventListener('transitionend',
//             () => element.style.display = 'none',
//             { once: true },
//         );
//     }
// }
export function slideToggle(element, timing = 500, attribute = 'height', display = 'block') {
    const isHidden = window.getComputedStyle(element).display === 'none';

    element.style.transition = `${attribute} ${timing}ms ease`;
    element.style.overflow = 'hidden';

    if (isHidden) {
        // Open
        element.style.display = display;
        element.style[attribute] = '0px';

        // Force reflow to make sure the transition will run
        void element.offsetHeight;

        const value = (attribute === 'width' ? element.scrollWidth : element.scrollHeight) + 'px';
        element.style[attribute] = value;

        // After transition ends, set height to auto
        element.addEventListener('transitionend', () => {
            element.style[attribute] = 'auto';
        }, { once: true });

    } else {
        // Close
        const currentValue = (attribute === 'width' ? element.scrollWidth : element.scrollHeight) + 'px';
        element.style[attribute] = currentValue;

        // Force reflow
        void element.offsetHeight;

        element.style[attribute] = '0px';

        element.addEventListener('transitionend', () => {
            element.style.display = 'none';
            element.style[attribute] = '';
        }, { once: true });
    }
}